function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { SettingOutlined } from '@ant-design/icons';
import { Checkbox, Popover, Tree } from 'antd';
import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { moveHide } from "../tools";
var getDefaultColumnsSettings = function getDefaultColumnsSettings(tableColumns) {
  return tableColumns.map(function (item, index) {
    return {
      order: item.order || index,
      // 顺序
      key: item.dataIndex,
      // 唯一标志
      hide: item.hide // 是否隐藏
    };
  });
};

var ToolBar = function ToolBar(_ref) {
  var tableColumns = _ref.tableColumns,
    setTableColumns = _ref.setTableColumns,
    onChangeColumns = _ref.onChangeColumns,
    _ref$columnsSettings = _ref.columnsSettings,
    columnsSettings = _ref$columnsSettings === void 0 ? [] : _ref$columnsSettings;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    checkedKeys = _useState2[0],
    setCheckedkeys = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    treeData = _useState4[0],
    setTreeData = _useState4[1];

  // 上面的fixed
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    topFixedCheckedKeys = _useState6[0],
    setTopFixedCheckedKeys = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    topFixedTreeData = _useState8[0],
    setTopFixedTreeData = _useState8[1];
  // 下面的fixed
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    fixedCheckedKeys = _useState10[0],
    setFixedCheckedKeys = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    fixedTreData = _useState12[0],
    setFixedTreeData = _useState12[1];

  // 列展示配置
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    checkAll = _useState14[0],
    setCheckAll = _useState14[1];
  var _useState15 = useState(true),
    _useState16 = _slicedToArray(_useState15, 2),
    indeterminate = _useState16[0],
    setIndeterminate = _useState16[1];

  // 获取用户的Columns
  var _useState17 = useState(!isEmpty(columnsSettings) ? columnsSettings : getDefaultColumnsSettings(moveHide(tableColumns))),
    _useState18 = _slicedToArray(_useState17, 2),
    defaultColumnsSettings = _useState18[0],
    setDefaultColumnsSettings = _useState18[1];
  var _useState19 = useState(!isEmpty(columnsSettings) ? columnsSettings : getDefaultColumnsSettings(moveHide(tableColumns))),
    _useState20 = _slicedToArray(_useState19, 2),
    currentColsettings = _useState20[0],
    setCurrentColSettings = _useState20[1];
  useEffect(function () {
    var allTreeData = [];
    currentColsettings.map(function (item) {
      var column = tableColumns.find(function (c) {
        return c.dataIndex === item.key;
      });
      allTreeData.push(_objectSpread(_objectSpread(_objectSpread({}, column), item), {}, {
        key: column === null || column === void 0 ? void 0 : column.dataIndex
      }));
    });
    var _treeData = allTreeData.filter(function (item) {
      return !item.fixed;
    });
    var _fixedTreeData = allTreeData.filter(function (item) {
      return item.fixed === 'right';
    });
    var _topFixedTreeData = allTreeData.filter(function (item) {
      return item.fixed === 'left';
    });
    var _checkedKeys = _treeData.filter(function (item) {
      return !item.hide;
    }).map(function (item) {
      return item.key;
    });
    setTreeData(_treeData);
    // 可以移动的columns的key(移除掉hide)
    setCheckedkeys(_checkedKeys);
    setFixedTreeData(_fixedTreeData);
    // 固定，不可移动的columns的key(下面的)
    setFixedCheckedKeys(_fixedTreeData.map(function (item) {
      return item.key;
    }));
    setTopFixedTreeData(_topFixedTreeData);
    // 固定，不可移动的columns的key(上面的)
    setTopFixedCheckedKeys(_topFixedTreeData.map(function (item) {
      return item.key;
    }));

    // 是否全选，判断checkedKeys的长度 是否等于treeData的长度
    setCheckAll(_checkedKeys.length === _treeData.length);
    setIndeterminate(_checkedKeys.length !== _treeData.length);
  }, [defaultColumnsSettings]);
  var handleCheck = function handleCheck(checkedKeysValue) {
    var allFixedCheckedKeys = [].concat(_toConsumableArray(topFixedCheckedKeys), _toConsumableArray(fixedCheckedKeys));
    var newColumnsSettings = currentColsettings.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        hide: allFixedCheckedKeys.includes(item.key) ? false : !checkedKeysValue.includes(item.key)
      });
    });
    var newTableColumns = currentColsettings.map(function (item) {
      var newItem = tableColumns.find(function (c) {
        return c.dataIndex === item.key;
      });
      return _objectSpread(_objectSpread(_objectSpread({}, newItem), item), {}, {
        hide: allFixedCheckedKeys.includes(item.key) ? false : !checkedKeysValue.includes(item.key)
      });
    });
    setCheckedkeys(checkedKeysValue);
    setIndeterminate(!!checkedKeysValue.length && checkedKeysValue.length < treeData.length);
    setCheckAll(checkedKeysValue.length === treeData.length);
    // 修改列表的columns
    setTableColumns(newTableColumns);
    setCurrentColSettings(function () {
      return _toConsumableArray(newColumnsSettings);
    });

    // 全局修改该页面下的columns
    onChangeColumns === null || onChangeColumns === void 0 || onChangeColumns(newColumnsSettings);
  };
  var handleChangeAll = function handleChangeAll(e) {
    var checked = e.target.checked;
    var _checkedKeys = treeData.map(function (item) {
      return item.key;
    });
    setCheckedkeys(checked ? _checkedKeys : []);
    setIndeterminate(false);
    setCheckAll(checked);
    var allFixedCheckedKeys = [].concat(_toConsumableArray(topFixedCheckedKeys), _toConsumableArray(fixedCheckedKeys));

    // 修改列表的columns
    var newColumnsSettings = currentColsettings.map(function (item) {
      return {
        key: item.key,
        order: item.order,
        hide: allFixedCheckedKeys.includes(item.key) ? false : !checked
      };
    });
    var newTableColumns = currentColsettings.map(function (item) {
      var newItem = tableColumns.find(function (c) {
        return c.dataIndex === item.key;
      });
      return _objectSpread(_objectSpread(_objectSpread({}, newItem), item), {}, {
        hide: allFixedCheckedKeys.includes(item.key) ? false : !checked
      });
    });

    // 修改列表的columns
    setTableColumns(newTableColumns);
    setCurrentColSettings(function () {
      return _toConsumableArray(newColumnsSettings);
    });
    // 全局修改该页面下的columns
    onChangeColumns === null || onChangeColumns === void 0 || onChangeColumns(newColumnsSettings);
  };

  // 拖动排序
  var handleDrop = function handleDrop(info) {
    var dragNode = info.dragNode,
      node = info.node,
      dropPosition = info.dropPosition;
    // 被拖动的节点的key
    var dragNodeKey = dragNode.key;
    // 目标位置的节点的key
    var dropNodekey = node.key;
    var dropPos = node.pos.split('-');
    var _dropPosition = dropPosition - Number(dropPos[dropPos.length - 1]);
    var dragNodeIndex = treeData.findIndex(function (item) {
      return item.key === dragNodeKey;
    });
    var dropNodeIndex = treeData.findIndex(function (item) {
      return item.key === dropNodekey;
    });

    // 先删除移动的元素
    treeData.splice(dragNodeIndex, 1);
    if (_dropPosition === -1) {
      treeData.splice(dropNodeIndex, 0, dragNode);
    } else {
      treeData.splice(dropNodeIndex + 1, 0, dragNode);
    }
    treeData.map(function (item, index) {
      return _objectSpread(_objectSpread({}, item), {}, {
        order: index + topFixedCheckedKeys.length + 1
      });
    });
    var allFixedCheckedKeys = [].concat(_toConsumableArray(topFixedCheckedKeys), _toConsumableArray(fixedCheckedKeys));
    var allTreeData = [].concat(_toConsumableArray(topFixedTreeData), _toConsumableArray(treeData), _toConsumableArray(fixedTreData));
    // 重新排序
    var newColumnsSettings = allTreeData.map(function (item, index) {
      return {
        key: item.key,
        hide: allFixedCheckedKeys.includes(item.key) ? false : !checkedKeys.includes(item.key),
        order: index + 1
      };
    });
    var newTableColumns = allTreeData.map(function (item, index) {
      return _objectSpread(_objectSpread({}, item), {}, {
        order: index + 1,
        hide: allFixedCheckedKeys.includes(item.key) ? false : !checkedKeys.includes(item.key)
      });
    });
    setTreeData(function () {
      return _toConsumableArray(treeData);
    });
    setTableColumns(newTableColumns);
    setCurrentColSettings(function () {
      return _toConsumableArray(newColumnsSettings);
    });
    onChangeColumns === null || onChangeColumns === void 0 || onChangeColumns(newColumnsSettings);
  };
  var renderActionBarOption = /*#__PURE__*/React.createElement("div", {
    className: "action_bar_option"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    indeterminate: indeterminate,
    checked: checkAll,
    onChange: handleChangeAll
  }, "\u5217\u5C55\u793A"), topFixedTreeData.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tree, {
    blockNode: true,
    checkable: true,
    draggable: true,
    selectable: false,
    checkedKeys: topFixedCheckedKeys,
    treeData: topFixedTreeData
  }), /*#__PURE__*/React.createElement("div", {
    className: "divider"
  })) : null, /*#__PURE__*/React.createElement(Tree, {
    blockNode: true,
    draggable: true,
    checkable: true,
    selectable: false,
    checkedKeys: checkedKeys,
    treeData: treeData
    // @ts-ignore
    ,
    onCheck: handleCheck,
    onDrop: handleDrop
  }), fixedTreData.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "divider"
  }), /*#__PURE__*/React.createElement(Tree, {
    blockNode: true,
    checkable: true,
    draggable: true,
    selectable: false,
    checkedKeys: fixedCheckedKeys,
    treeData: fixedTreData
  })) : null);
  return /*#__PURE__*/React.createElement(Popover, {
    placement: "bottomRight",
    title: null,
    content: renderActionBarOption
  }, /*#__PURE__*/React.createElement(SettingOutlined, {
    rev: undefined
  }));
};
export default ToolBar;